import NarrativeTypes from '~/constants/vdp/narrativeTypes';
import { Configuration } from '~/contracts/common';
import Narratives, {
  type Narrative,
  type NarrativeContent
} from '~/contracts/vdp/Narratives';

export function getNarrative(
  vaultWhyBuyNarrativeConfig?: Configuration['VaultWhyBuyNarrativeConfig'],
  narratives?: Narratives
): Narrative {
  if (!narratives || !vaultWhyBuyNarrativeConfig) return {};

  const findNarrative = (version: string) =>
    version
      ? narratives.find(
          n =>
            n?.narrativeType === NarrativeTypes.VIN_WHY_BUY &&
            n?.narrativeVersion === version
        )
      : undefined;

  const { control = '', treatment = '' } =
    vaultWhyBuyNarrativeConfig.bucket ?? {};

  return findNarrative(treatment) ?? findNarrative(control) ?? {};
}

export function hasVaultWhyBuyData(
  narrativeContent?: Partial<NarrativeContent>
): boolean {
  return (
    Boolean(narrativeContent?.summary) &&
    Array.isArray(narrativeContent?.bulletPoints) &&
    (narrativeContent?.bulletPoints?.length ?? 0) > 0
  );
}
